export default "__VITE_ASSET__IIEZfqp1__"